import Placeholder from "@Resources/game/backgrounds/3.jpg";
import { Box, SxProps, useTheme } from '@mui/material';
import BybConditionalWrapper from '../byb-conditional-wrapper';
import BybImageWrapper, { IBybImageWrapper } from '../byb-image-wrapper';
import BybSticker from '../byb-sticker';
import BybSection from './byb-section';

interface IBybImageSection extends IBybImageWrapper {
  children?: React.ReactNode;
  imgSrc?: string | null;
  imgSize?: 'small' | 'medium' | 'large';
  topRightSticker?: React.ReactNode;
  topLeftSticker?: React.ReactNode;
  bottomRightSticker?: React.ReactNode;
  bottomLeftSticker?: React.ReactNode;
  sx?: SxProps;
  onClick?: () => void;
}

const BybImageSection = ({
  children,
  imgSrc,
  imgSize = 'medium',
  topRightSticker,
  topLeftSticker,
  bottomRightSticker,
  bottomLeftSticker,
  href,
  sx,
  onImageClick,
  onClick,
}: IBybImageSection) => {
  const theme = useTheme();

  return (
    <BybSection sx={sx}>
      <BybConditionalWrapper
        condition={!!onClick}
        trueWrapper={(children) => <Box onClick={onClick}>{children}</Box>}
        falseWrapper={(children) => children}
      >
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <BybImageWrapper href={href} onImageClick={onImageClick}>
            <img
              src={imgSrc || Placeholder}
              alt="placeholder"
              loading="lazy"
              decoding="async"
              style={{
                height:
                  imgSize === 'small'
                    ? theme.spacing(15)
                    : imgSize === 'medium'
                    ? theme.spacing(22.5)
                    : theme.spacing(27.5),
                width: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
              }}
            />
          </BybImageWrapper>
          {topRightSticker && (
            <BybSticker anchor="top-right" margin={2.5} sx={{ backgroundColor: 'dsSurface.v100' }}>
              {topRightSticker}
            </BybSticker>
          )}
          {topLeftSticker && (
            <BybSticker anchor="top-left" margin={2.5} sx={{ backgroundColor: 'dsSurface.v100' }}>
              {topLeftSticker}
            </BybSticker>
          )}
          {bottomRightSticker && (
            <BybSticker anchor="bottom-right" margin={2.5} sx={{ backgroundColor: 'dsSurface.v100' }}>
              {bottomRightSticker}
            </BybSticker>
          )}
          {bottomLeftSticker && (
            <BybSticker anchor="bottom-left" margin={2.5} sx={{ backgroundColor: 'dsSurface.v100' }}>
              {bottomLeftSticker}
            </BybSticker>
          )}
        </Box>
        {children}
      </BybConditionalWrapper>
    </BybSection>
  );
};

export default BybImageSection;
